module.exports = __webpack_public_path__ + "static/green-ea5c6516021eb645ff2f5f1748e797d0.svg";